import React from 'react';

const CookieConsent = ({ onAccept }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-zinc-900 border-t border-zinc-800 p-6 shadow-lg">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-white/90 text-sm">
          Käytämme evästeitä parantaaksemme käyttökokemustasi. Jatkamalla sivuston käyttöä 
          hyväksyt evästeiden käytön ja tietosuojakäytäntömme.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={onAccept}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold transition-all duration-300"
          >
            Hyväksyn
          </button>
          <button
            onClick={onAccept}
            className="text-white/70 hover:text-white px-4 py-2 transition-colors"
          >
            Lue lisää
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
